/**
 * Created by AlexanderC on 5/22/15.
 *
 * Bootstrap file loaded by npm as main
 */

'use strict';

var _Log = require('./Log');

module.exports = _Log.Log;


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/bootstrap.js
// module id = 412
// module chunks = 0